import { AuthMiddlewareActionTypes, AuthMiddlewareState } from 'interfaces'

type Action =
  | { type: AuthMiddlewareActionTypes.SET_LOADING; payload: boolean }
  | { type: AuthMiddlewareActionTypes.SET_AUTHENTICATED; payload: boolean }
  | { type: AuthMiddlewareActionTypes.SET_WAS_VALIDATED; payload: boolean }
  | { type: AuthMiddlewareActionTypes.SET_IS_COMPLETE; payload: boolean }

export const authMiddlewareReducer = (
  state: AuthMiddlewareState,
  action: Action
): AuthMiddlewareState => {
  switch (action.type) {
    case AuthMiddlewareActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case AuthMiddlewareActionTypes.SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload,
      }

    case AuthMiddlewareActionTypes.SET_WAS_VALIDATED:
      return {
        ...state,
        wasValidated: action.payload,
      }

    case AuthMiddlewareActionTypes.SET_IS_COMPLETE:
      return {
        ...state,
        isComplete: action.payload,
      }

    default:
      return state
  }
}
